import {combineReducers, createStore} from "redux";
import panelHeaderReducer from '../reducers/PanelHeader';
import AlertReducer from "../reducers/AlertReducer";
import panelScrollReducer from "../reducers/PanelScroll";
import LangReducer from "../reducers/LangReducer";
import RowCountReducer from "../reducers/RowCountReducer";
import CalendarReducer from "../reducers/CalendarReducer";
import LoadingReducer from "../reducers/LoadingReducer";
import UserSettingsReducer from "../reducers/UserSettingsReducer";
import DeviceModeReducer from "../reducers/DeviceModeReducer";
import panelScrollingReducer from "../reducers/PanelScrollingReducer";
import ChangesLogReducer from "../reducers/ChangesLogReducer";

export const allReducer = combineReducers({
    panelHeaderReducer,
    panelScrollReducer,
    AlertReducer,
    LangReducer,
    RowCountReducer,
    CalendarReducer,
    LoadingReducer,
    UserSettingsReducer,
    DeviceModeReducer,
    panelScrollingReducer,
    ChangesLogReducer
});

export const Store = createStore(allReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );